import { __exports as auto } from "./index220.js";
import { __require as requireConstants } from "./index196.js";
var hasRequiredAuto;
function requireAuto() {
  if (hasRequiredAuto) return auto;
  hasRequiredAuto = 1;
  Object.defineProperty(auto, "__esModule", {
    value: true
  });
  var _constants = requireConstants();
  var matchSetALength = function matchSetALength2(string) {
    return string.match(new RegExp("^" + _constants.A_CHARS + "*"))[0].length;
  };
  var matchSetBLength = function matchSetBLength2(string) {
    return string.match(new RegExp("^" + _constants.B_CHARS + "*"))[0].length;
  };
  var matchSetC = function matchSetC2(string) {
    return string.match(new RegExp("^" + _constants.C_CHARS + "*"))[0];
  };
  function autoSelectFromAB(string, isA) {
    var ranges = isA ? _constants.A_CHARS : _constants.B_CHARS;
    var untilC = string.match(new RegExp("^(" + ranges + "+?)(([0-9]{2}){2,})([^0-9]|$)"));
    if (untilC) {
      return untilC[1] + String.fromCharCode(204) + autoSelectFromC(string.substring(untilC[1].length));
    }
    var chars = string.match(new RegExp("^" + ranges + "+"))[0];
    if (chars.length === string.length) {
      return string;
    }
    return chars + String.fromCharCode(isA ? 205 : 206) + autoSelectFromAB(string.substring(chars.length), !isA);
  }
  function autoSelectFromC(string) {
    var cMatch = matchSetC(string);
    var length = cMatch.length;
    if (length === string.length) {
      return string;
    }
    string = string.substring(length);
    var isA = matchSetALength(string) >= matchSetBLength(string);
    return cMatch + String.fromCharCode(isA ? 206 : 205) + autoSelectFromAB(string, isA);
  }
  auto.default = function(string) {
    var newString = void 0;
    var cLength = matchSetC(string).length;
    if (cLength >= 2) {
      newString = _constants.C_START_CHAR + autoSelectFromC(string);
    } else {
      var isA = matchSetALength(string) > matchSetBLength(string);
      newString = (isA ? _constants.A_START_CHAR : _constants.B_START_CHAR) + autoSelectFromAB(string, isA);
    }
    return newString.replace(
      /[\xCD\xCE]([^])[\xCD\xCE]/,
      // Any sequence between 205 and 206 characters
      function(match, char) {
        return String.fromCharCode(203) + char;
      }
    );
  };
  return auto;
}
export {
  requireAuto as __require
};
//# sourceMappingURL=index194.js.map
